__turbopack_context__.v({
  "bottomJaw": "style-module-scss-module__n1go1G__bottomJaw",
  "contactButton": "style-module-scss-module__n1go1G__contactButton",
  "contactButtonText": "style-module-scss-module__n1go1G__contactButtonText",
  "content": "style-module-scss-module__n1go1G__content",
  "inner": "style-module-scss-module__n1go1G__inner",
  "jaw": "style-module-scss-module__n1go1G__jaw",
  "logosWrapper": "style-module-scss-module__n1go1G__logosWrapper",
  "pinScene": "style-module-scss-module__n1go1G__pinScene",
  "section": "style-module-scss-module__n1go1G__section",
  "text": "style-module-scss-module__n1go1G__text",
  "title": "style-module-scss-module__n1go1G__title",
  "topJaw": "style-module-scss-module__n1go1G__topJaw",
  "wrapperJaws": "style-module-scss-module__n1go1G__wrapperJaws",
});
